document.addEventListener('DOMContentLoaded', function () {
  const sliders = document.querySelectorAll('.splide');

  if (!sliders.length) return;

  sliders.forEach((sliderElement) => {
    const slider = new Splide(sliderElement, {
      type: 'slide',
      arrows: true,
      pagination: false,
      perPage: 2,
      perMove: 1,
      drag: true,
      speed: 600,
      gap: 8,
      mediaQuery: 'min',
      breakpoints: {
        768: {
          destroy: true
        }
      }
    });

    slider.mount();
  });
});
